import {loadGoogleMapsApi} from "@pg-mono/google-api";

import {TravelMode} from "../../property/utils/TravelMode";

type DistanceResponseType = {type: TravelMode; value: number};
type CoordsType = {lat: number; lng: number};

export const fetchTravelDirections = async ({
    origin,
    destination,
    travelMode
}: {
    origin: CoordsType;
    destination: CoordsType;
    travelMode: TravelMode;
}): Promise<DistanceResponseType | null> => {
    await loadGoogleMapsApi(["places"]);

    return new Promise((resolve) => {
        // IMPORTANT: be aware of that this API is really expensive - consult usage with business
        const directionsService = new google.maps.DirectionsService();

        const request = {
            destination: new google.maps.LatLng(destination.lat, destination.lng),
            origin: new google.maps.LatLng(origin.lat, origin.lng),
            travelMode
        };

        directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK && result) {
                const route = result.routes[0];
                const duration = route.legs[0].duration?.value || 0;

                return resolve({type: request.travelMode as TravelMode, value: duration});
            }
            return resolve(null);
        });
    });
};
import {loadGoogleMapsApi} from "@pg-mono/google-api";

import {TravelMode} from "../../property/utils/TravelMode";

type DistanceResponseType = {type: TravelMode; value: number};
type CoordsType = {lat: number; lng: number};

export const fetchTravelDirections = async ({
    origin,
    destination,
    travelMode
}: {
    origin: CoordsType;
    destination: CoordsType;
    travelMode: TravelMode;
}): Promise<DistanceResponseType | null> => {
    await loadGoogleMapsApi(["places"]);

    return new Promise((resolve) => {
        // IMPORTANT: be aware of that this API is really expensive - consult usage with business
        const directionsService = new google.maps.DirectionsService();

        const request = {
            destination: new google.maps.LatLng(destination.lat, destination.lng),
            origin: new google.maps.LatLng(origin.lat, origin.lng),
            travelMode
        };

        directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK && result) {
                const route = result.routes[0];
                const duration = route.legs[0].duration?.value || 0;

                return resolve({type: request.travelMode as TravelMode, value: duration});
            }
            return resolve(null);
        });
    });
};
